import { render, staticRenderFns } from "./_type.vue?vue&type=template&id=118f3fcf&scoped=true"
import script from "./_type.vue?vue&type=script&lang=js"
export * from "./_type.vue?vue&type=script&lang=js"
import style0 from "./_type.vue?vue&type=style&index=0&id=118f3fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f3fcf",
  null
  
)

export default component.exports